module.exports = __webpack_public_path__ + "media/video_full.d71f82f8.mp4";